import { render, staticRenderFns } from "./RecommendationResultsDashboard.vue?vue&type=template&id=1a581741"
import script from "./RecommendationResultsDashboard.vue?vue&type=script&lang=js"
export * from "./RecommendationResultsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports